export var ICON_SIZE = 18;
// colors moved to Oskari.app.getTheming().getTheme()